import { useEffect, useRef } from 'react';

const contactInfo = [
  {
    icon: 'ri-map-pin-2-line',
    color: 'bg-orange-500',
    title: 'Adres',
    lines: [
      'Mehmet Abdi Bulut Mh. Fatma Şahin Cd. No:10',
      'Merkez / Kilis',
    ],
  },
  {
    icon: 'ri-phone-line',
    color: 'bg-slate-800',
    title: 'Telefon',
    lines: ['0 538 232 38 22', '0 532 453 99 79'],
  },
  {
    icon: 'ri-whatsapp-line',
    color: 'bg-emerald-600',
    title: 'WhatsApp',
    lines: ['0 538 232 38 22'],
  },
];

export default function Contact() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-10');
          }
        });
      },
      { threshold: 0.1 }
    );
    const children = sectionRef.current?.querySelectorAll('.animate-on-scroll');
    children?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="iletisim" className="py-24" style={{ background: '#f8f6f3' }} ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700">
          <span className="text-orange-500 text-sm font-bold uppercase tracking-widest mb-3 block">
            İletişim
          </span>
          <h2
            className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-4"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Bizimle <span className="text-orange-500">İletişime Geçin</span>
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            Taşımacılık ihtiyaçlarınız için bize ulaşın, size en uygun çözümü sunalım.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-10">
          {/* Left: Contact Info + Image */}
          <div className="w-full lg:w-1/2 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 flex flex-col gap-5">
            {contactInfo.map((info) => (
              <div key={info.title} className="flex items-start gap-4 bg-white rounded-xl p-6">
                <div className={`w-12 h-12 flex items-center justify-center ${info.color} rounded-xl flex-shrink-0`}>
                  <i className={`${info.icon} text-white text-xl`} />
                </div>
                <div>
                  <div className="font-bold text-gray-800 text-sm mb-1">{info.title}</div>
                  {info.lines.map((line) => (
                    <div key={line} className="text-gray-500 text-sm">{line}</div>
                  ))}
                </div>
              </div>
            ))}

            {/* Quick Contact Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 mt-2">
              <a
                href="tel:05382323822"
                className="flex-1 flex items-center justify-center gap-2 bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-fill text-lg" />
                Hemen Ara
              </a>
              <a
                href="https://wa.me/905382323822?text=Merhaba%2C%20lojistik%20hizmetleriniz%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-4 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-lg" />
                WhatsApp
              </a>
            </div>
          </div>

          {/* Right: Map */}
          <div className="w-full lg:w-1/2 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 flex flex-col gap-5">
            <div className="rounded-2xl overflow-hidden flex-1 min-h-[420px]">
              <iframe
                title="Global79 Lojistik Konum"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3168.0!2d37.1167!3d36.7167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDQzJzAwLjAiTiAzN8KwMDcnMDAuMCJF!5e0!3m2!1str!2str!4v1680000000000!5m2!1str!2str"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
